import { Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useNavbar } from "../context/NavbarContext";
import Home from "../pages/Home";
import AboutUs from "../pages/AboutUs"; // Who we are
import WomensCare from "../pages/WomensCare";
import ChildCare from "../pages/ChildCare";
import BehavioralHealth from "../pages/BehavioralHealth";
import Aida from "../pages/AiDA";
import DigitalHealthPlatform from "../pages/DigitalHealthPlatform";
import AMI from "../pages/AMI";
import ResearchAndInnovation from "../pages/Research";
import DigitalHealth from "../pages/DigitalHealth";
import DigitalTransformation from "../pages/DigitalTransformation";
import GetInTouch from "../pages/GetInTouch";
import OneCare from "../pages/OneCare";
import EDG from "../pages/EDG";
// Define which routes should use light navbar
const LIGHT_NAVBAR_ROUTES = [
  "/",
  "/about-us",
  "/womens-care",
  "/child-care",
  "/behavioral-health",
  "/one-care",
  "/research",
  "/edg",
  "/aida",
  "/digital-health",
  "/digital-transformation",
  "/get-in-touch",
  "/edg",
];

const AppRoutes = () => {
  const location = useLocation();
  const { setVariant } = useNavbar();

  useEffect(() => {
    // Update navbar variant based on current route
    if (LIGHT_NAVBAR_ROUTES.includes(location.pathname)) {
      setVariant("light");
    } else {
      setVariant("dark");
    }
  }, [location.pathname, setVariant]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/womens-care" element={<WomensCare />} />
      <Route path="/child-care" element={<ChildCare />} />
      <Route path="/behavioral-health" element={<BehavioralHealth />} />
      <Route path="/aida" element={<Aida />} />
      <Route path="/one-care" element={<OneCare />} />
      <Route
        path="/digital-health-platform"
        element={<DigitalHealthPlatform />}
      />
      <Route path="/digital-health" element={<DigitalHealth />} />
      <Route path="/ami" element={<AMI />} />
      <Route path="/research" element={<ResearchAndInnovation />} />
      <Route
        path="/digital-transformation"
        element={<DigitalTransformation />}
      />
      <Route path="/get-in-touch" element={<GetInTouch />} />
      <Route path="/one-care" element={<OneCare />} />
      <Route path="/edg" element={<EDG />} />
    </Routes>
  );
};

export default AppRoutes;
